// CardSection.tsx
import React from 'react';
import { GraphDownArrow, GraphUpArrow } from 'react-bootstrap-icons';
import { FaInfoCircle } from 'react-icons/fa';
import { formatCurrency } from '../../../../../../utils/functions';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import './CardSection.scss';

type CardSectionProps = {
  totalCurrentMonth: number;
  averageExpense: number;
  variationPercent: number;
  isNegative: boolean;
};

/**
 * Muestra los 3 Cards con información de salarios.
 */
const CardSection: React.FC<CardSectionProps> = ({
  totalCurrentMonth,
  averageExpense,
  variationPercent,
  isNegative,
}) => {
  const variationColor = isNegative ? 'green' : 'red';
  const arrowIcon = isNegative ? <GraphDownArrow /> : <GraphUpArrow />;

  return (
    <div className="salary-cards-row" style={{ display: 'flex', gap: '5px', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
      {/* Card #1: Total mes actual */}
      <div className="salary-card">
        <div className="card-accent-bar" />
        <div className="card-body">
          <div className="card-title">Total mes actual</div>
          <div className="card-value">{formatCurrency(totalCurrentMonth)}</div>
        </div>
      </div>

      {/* Card #2: Promedio de salarios en el rango */}
      <div className="salary-card">
        <div className="card-accent-bar" />
        <div className="card-body">
          <div className="card-title">Promedio salarios en el mes actual</div>
          <div className="card-value">{formatCurrency(averageExpense)}</div>
        </div>
      </div>

      {/* Card #3: Variación porcentual vs mes anterior */}
      <div className="salary-card">
        <div className="card-accent-bar" />
        <div className="card-body">
          <div className="card-title">
            Variación % del salario
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip>
                  <div style={{ textAlign: 'center', whiteSpace: 'normal' }}>
                    Porcentaje de variación del salario con respecto al mes anterior.
                  </div>
                </Tooltip>
              }
            >
              <span className="ms-2 info-create-item" style={{ cursor: 'pointer', marginLeft: '0.5rem' }}>
                <FaInfoCircle color="#6c757d" />
              </span>
            </OverlayTrigger>
          </div>
          <div className="card-value" style={{ color: variationColor }}>
            {variationPercent.toFixed(2)}% {arrowIcon}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardSection;
